export default {
  buttons: {
    more_payment_methods: 'Więcej metod płatności',
  },
  toasts: {
    processing: 'Przetwarzamy dane płatności. Powiadomimy Cię po zakończeniu przetwarzania.',
    failed: 'Nie udało się przetworzyć danych płatności. Wypróbuj inną metodę płatności.',
    failed_to_load: 'Nie udało się załadować formularza płatności. Odśwież stronę i spróbuj ponownie.',
    failed_to_save_payment_method: 'Nie udało się zapisać metody płatności',
    failed_to_create_checkout_session: 'Coś poszło nie tak, spróbuj ponownie',
  },
};
